import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

const propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  emptyValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const defaultProps = {
  label: null,
  required: false,
  emptyValue: null,
  data: [],
};

/** */
export default function Dropdown(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { name, label, required, emptyValue, data, value, ...select } = props;

  return (
    <div
      id={`Form_Form_${name}_Holder`}
      className="control-group field dropdown"
    >
      <label className="left" htmlFor={`Form_Form_${name}_Holder`}>
        {label ?? name}
        {required && (
          <>
            &nbsp;<span className="req-indicator">*</span>
          </>
        )}
      </label>

      <select
        name={name}
        className="dropdown"
        id={`Form_Form_${name}`}
        required={required}
        aria-required={required}
        value={value ?? emptyValue}
        {...select}
      >
        {emptyValue && <option value={emptyValue}>{emptyValue}</option>}
        {data.map((value, index) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </select>
    </div>
  );
}
Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
